<template>
  <div
    class="post-text-section d-flex justify-content-start align-items-start nowrap"
  >
    <!-- INVISIBLE AVATAR -->
    <div class="avatar invisible d-none d-md-block"></div>
    <!-- INVISIBLE AVATAR -->

    <div class="color_ash text-content" v-html="renderText"></div>
  </div>
</template>

<script>
export default {
  name: "PostTextBlock",

  props: {
    post: Object,
  },

  computed: {
    renderText() {
      return this.URLify(this.post.description);
    },
  },

  filters: {},

  methods: {
    URLify(string) {
      let urls = string.match(/(http|www|https)?:\/\/(\S+)/gi);
      if (urls) {
        urls.forEach(function(url) {
          string = string.replace(
            url,
            '<a target="_blank" href="' + url + '">' + url + "</a>"
          );
        });
      }
      return string.replace("(", "");
    },
  },
};
</script>

<style lang="scss">
.post-text-section {
  box-sizing: border-box;
  padding: 0px 2px;
  width: 96.5%;

  @include breakpoint_max(sm) {
    margin-bottom: 0px;
  }

  .avatar {
    margin-right: 25px;
    @include equal_min_edge(14);
  }

  .text-content {
    position: relative;
    font-size: 13px;
    line-height: 23px;
    white-space: pre-line;
    word-wrap: break-word;
    left: 16.45px;
    padding-right: 20px;
    font-family: "Noto Sans";

    p {
      white-space: pre-line;
    }

    a {
      color: $brand_inverse;
      word-break: break-all;
      display: block;
      text-decoration: underline;
    }

    @include breakpoint_max(sm) {
      line-height: 18px;
      font-size: 12.5px;
      position: relative;
      left: 11px;
    }

    @include breakpoint_max(xs) {
      font-size: 12.4px;
    }
  }
}
</style>
